function addToCartCount(amount) {
    const cartCountEl = document.querySelector('.js-cart-count');
    const currentCartCount = cartCountEl.innerText ? Number(cartCountEl.innerText) : 0;
    cartCountEl.innerText = currentCartCount + amount;
}

export { addToCartCount };
